var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 263,
    height: 211,
    viewBox: "0 0 263 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01_wallet_illustration 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.18,
    d: "M64.8737 65.9376H206.894C213.672 65.9376 219.167 71.4482 219.167 78.2459V154.733C219.167 161.531 213.672 167.042 206.894 167.042H64.8737C58.0954 167.042 52.6004 161.531 52.6004 154.733V78.2459C52.6004 71.4482 58.0954 65.9376 64.8737 65.9376Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.18,
    d: "M52.6004 78.2459C52.6004 70.0404 56.6915 65.9376 64.8737 65.9376H184.1C198.712 65.9376 206.017 73.264 206.017 87.9167V101.104C206.017 106.965 203.095 109.896 197.25 109.896H113.967C108.123 109.896 105.2 106.965 105.2 101.104V87.9167C105.2 81.4695 102.278 78.2459 96.4338 78.2459H52.6004Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.18,
    d: "M65.751 140.667H206.018",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.18,
    d: "M73.6396 118.688H145.526C147.463 118.688 149.033 120.262 149.033 122.204V130.996C149.033 132.938 147.463 134.513 145.526 134.513H73.6396C71.7029 134.513 70.1329 132.938 70.1329 130.996V122.204C70.1329 120.262 71.7029 118.688 73.6396 118.688Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.18,
    d: "M203.387 116.49C203.387 119.888 200.64 122.644 197.251 122.644C193.861 122.644 191.114 119.888 191.114 116.49C191.114 113.091 193.861 110.335 197.251 110.335C200.64 110.335 203.387 113.091 203.387 116.49Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.18,
    d: "M199.881 116.49C199.881 117.946 198.703 119.127 197.251 119.127C195.798 119.127 194.621 117.946 194.621 116.49C194.621 115.033 195.798 113.852 197.251 113.852C198.703 113.852 199.881 115.033 199.881 116.49Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.18,
    d: "M85.0376 52.7501C85.0376 61.0045 78.3651 67.6959 70.1343 67.6959C61.9034 67.6959 55.2309 61.0045 55.2309 52.7501C55.2309 44.4957 61.9034 37.8043 70.1343 37.8043C78.3651 37.8043 85.0376 44.4957 85.0376 52.7501Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.18,
    d: "M79.7767 52.75C79.7767 58.0911 75.4592 62.4209 70.1333 62.4209C64.8075 62.4209 60.49 58.0911 60.49 52.75C60.49 47.409 64.8075 43.0792 70.1333 43.0792C75.4592 43.0792 79.7767 47.409 79.7767 52.75Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.18,
    d: "M66.6262 52.7501H73.6395M70.1329 49.2334V56.2667",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.18,
    d: "M108.267 40.4417C108.267 45.7828 103.95 50.1125 98.624 50.1125C93.2981 50.1125 88.9807 45.7828 88.9807 40.4417C88.9807 35.1007 93.2981 30.7709 98.624 30.7709C103.95 30.7709 108.267 35.1007 108.267 40.4417Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.18,
    d: "M104.324 40.4417C104.324 43.5978 101.773 46.1563 98.6257 46.1563C95.4786 46.1563 92.9274 43.5978 92.9274 40.4417C92.9274 37.2857 95.4786 34.7272 98.6257 34.7272C101.773 34.7272 104.324 37.2857 104.324 40.4417Z",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.18,
    d: "M89.8579 30.7708C85.4746 21.9791 78.8996 19.0486 70.1329 21.9791",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.18,
    d: "M39.4498 180.229H232.316",
    strokeWidth: 0.570732,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMobile);
export default __webpack_public_path__ + "static/media/wallet-mobile.bb1375ca67e5546eff72b261f3df1622.svg";
export { ForwardRef as ReactComponent };